export enum UserFeedTabSearchParam {
  Connections = "?view=connections",
  Comparisons = "?view=comparisons",
  Logs = "?view=logs",
  Settings = "?view=settings",
  ExternalProperties = "?view=external-properties",
}
